
import {Icons} from "./svgIcons";

const homePageData = {
  process: {
    title: "Our Development Process",
    steps: [
      { num: "01", translateKey: "discovery", translateDesc: "weAnalyze" },
      { num: "02", translateKey: "design", translateDesc: "uiuxWireframes" },
      { num: "03", translateKey: "development", translateDesc: "agileSprints" },
      { num: "04", translateKey: "delivery", translateDesc: "testingDeployment" }
    ]
  },
  services: {
    title: "Our Services",
    subtitle: "End-to-end software development solutions to your business needs",
    web: {
      title: "Web Application Development",
      short: "Web Applications",
      desc: "Scalable, high-performance web applications built with cutting-edge technologies. From SPAs to enterprise portals, we deliver exceptional digital experiences.",
      features: ["React / Vue / Angular", "Node.js & Cloud APIs", "E-commerce Platforms", "Enterprise Portals", "Progressive Web Apps"]
    },
    mobile: {
      title: "Mobile Application Development",
      short: "Mobile Applications",
      desc: "Native and cross-platform mobile apps for iOS and Android that users love. Seamless UX with powerful backend integrations.",
      features: ["iOS & Android", "React Native / Flutter", "UI/UX Design", "App Store Deployment", "Push Notifications"]
    },
    desktop: {
      title: "Desktop Application Development",
      short: "Desktop Applications",
      desc: "Powerful desktop solutions for Windows, macOS, and Linux. High-performance applications for demanding business workflows.",
      features: ["Windows / macOS / Linux", "Electron & .NET", "Offline Capability", "System Integration", "Auto-updates"]
    },
    custom: {
      title: "Customized Software Solutions",
      short: "Custom Software",
      desc: "Bespoke software engineered precisely to your business requirements. ERP, CRM, and custom workflows that scale with your growth.",
      features: ["ERP & CRM Systems", "Business Automation", "Legacy Modernization", "API Integrations", "Data Analytics"]
    }
  },
}

const serviceCards = [
  {
    key: 'web',
    url: "/services/web-application-development",
    icon: <Icons.Globe />, href: '/services/web',
    img: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=600&q=80',
    color: 'from-blue-500 to-indigo-600',
    title: "webApplicationDevelopment",
    short: "webApplications",
    desc: "scalableWebApp",
    // features: "reactVueWeApp",
    features: ["React / Vue / Angular", "Node.js & Cloud APIs", "E-commerce Platforms", "Enterprise Portals", "Progressive Web Apps"],
  },
  {
    key: 'mobile',
    url: "/services/mobile-development",
    icon: <Icons.Mobile />, href: '/services/mobile',
    img: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&q=80',
    color: 'from-purple-500 to-pink-600',
    title: "mobileApplicationDevelopment",
    short: "mobileApp",
    desc: "nativeCross",
    features: ["IOS & Android", "React Native / Flutter", "UI/UX Design", "App Store Deployment", "Push Notifications"]
  },
  {
    key: 'desktop',
    url: "/services/erp-solutions",
    icon: <Icons.Monitor />, href: '/services/desktop',
    img: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=600&q=80',
    color: 'from-cyan-500 to-blue-600',
    title: "desktopApplicationDevelopment",
    short: "desktopApplication",
    desc: "powerfulDesktop",
    features: ["Windows / macOS / Linux", "Electron & .NET", "Offline Capability", "System Integration", "Auto-updates"]
  },
  {
    key: 'custom',
    url: "/services/customized-software",
    icon: <Icons.Settings />, href: '/services/custom',
    img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
    color: 'from-orange-500 to-red-600',
    title: "customizedSoftwareSolutions",
    short: "customizedSoftware",
    desc: "bespokeSoftware",
    features: ["ERP & CRM Systems", "Business Automation", "Legacy Modernization", "API Integrations", "Data Analytics"]
  },
];

const whyChoose = [
  { title: "gccExpertise", desc: "deepUnderstanding" },
  { title: "agileDelivery", desc: "rapidIteration" },
  { title: "24Support", desc: "RoundThe" },
  { title: "globalStandard", desc: "internationalCoding" }
]

const seoData = {
  keywords: 'MAJ Technology L.L.C Software Development EMR Electronic Medical Records Health Records Dubai Medical Records Application emr-clini-visita NABIDH DHA dubai clinic software CliniVista majtech.ae, software development companies, software development company, it solutions custom software development Dubai, custom software development UAE, custom software development Abu Dhabi, customised software, custom software development agency,software development UAE, custom software development services company, software development custom software development, visitor management solution, visitor management system, visitor management software, visitor management system for office, guest management software, visitor system, office visitor management system, guest registration software, visitor management system kiosk, visitor management kiosk systems, kiosk based visitor management system, visitor management system mobile app, data center monitoring, environmental monitoring system, server room environmental monitoring, data center environmental monitoring, meeting room solutions, meeting room manager, meeting room system, conference room booking system, conference room reservation system, meeting room reservation system, conference room system, meeting room conference system, boardroom solutions, conference hall booking system, best file sharing for small business, file sharing solutions for small business, file sharing software for business, best file sharing software for business https://www.majtech.ae/services/customized-software/ تطوير برمجيات مخصصة  شركة تطوير برمجيات مخصصةبرمجيات مخصصةوكالةتطوير برمجيات مخصصة شركة خدمات تطوير برمجيات مخصصةتطوير برمجيات\n' +
  '\n' +
  'نظام إدارة الزوار\n' +
  'برنامج إدارة الزوار\n' +
  'نظام إدارة الزوار للمكاتب\n' +
  'برنامج إدارة الضيوف\n' +
  'نظام الزوار\n' +
  'نظام إدارة زوار المكاتب\n' +
  'برنامج تسجيل الضيوف\n' +
  'نظام إدارة الزوار عبر الأكشاك\n' +
  'أنظمة أكشاك إدارة الزوار\n' +
  'نظام إدارة الزوار عبر الأكشاك\n' +
  'تطبيق جوال لنظام إدارة الزوار\n' +
  '\n' +
  'مراقبة مركز البيانات\n' +
  'نظام مراقبة البيئة\n' +
  'مراقبة بيئة غرفة الخادم\n' +
  'مراقبة بيئة مركز البيانات\n' +
  '\n' +
  'حلول غرف الاجتماعات\n' +
  'مدير غرفة الاجتماعات\n' +
  'نظام غرف الاجتماعات\n' +
  'نظام حجز غرف المؤتمرات\n' +
  'نظام حجز غرف المؤتمرات\n' +
  'نظام غرف الاجتماعات\n' +
  'نظام مؤتمرات غرف الاجتماعات\n' +
  'حلول غرف الاجتماعات\n' +
  'نظام حجز قاعات المؤتمرات\n' +
  '\n' +
  'أفضل مشاركة ملفات للشركات الصغيرة\n' +
  'حلول مشاركة ملفات للشركات الصغيرة\n' +
  'برنامج مشاركة ملفات للشركات\n' +
  'أفضل برنامج مشاركة ملفات',
  description: 'MAJ Technology L.L.C is a leading Technology and Software Solutions Provider with years of expertise in providing cost effective and customized software solutions to various clients in the United Arab Emirates and in the GCC.'

}


export {
  homePageData,
  serviceCards,
  whyChoose,
  seoData
}
